import { UPDATE_SEARCHTDATA_CAUHINHGOITRAGOP } from "../../../actions/CauHinhGoiTraGop/actionTypes";

const initialState = {
  sSearch: "",
  bStatus: "",
  iPageIndex: 1,
  iPageSize: 25,
};

const updateDataSearch = (state, action) => ({
  ...action.payload,
});

export const dataSearchCauHinhGoiTraGop = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_CAUHINHGOITRAGOP:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchCauHinhGoiTraGop;
